var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdxSerial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255,
    height: 148.607,
    viewBox: "0 0 255 148.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1659",
    x: 74.833,
    y: 0,
    width: 180.168,
    height: 99.427,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#793170",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657",
    transform: "translate(-473.5 -256.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656",
    transform: "translate(8666 -10391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_35",
    "data-name": "Union 35",
    d: "M48,77.069c-1.664,0-31.256.087-37.626,0-6.554-.09-8.8-2.627-9.793-10.094S.007,18.9.841,11.182,8.905,2.59,13.989,2.537s27.993-.159,27.993-.159S42.691.043,47.922,0h.146c5.231.043,5.94,2.377,5.94,2.377S76.917,2.483,82,2.537s12.314.931,13.148,8.645,1.258,48.326.264,55.793-3.239,10-9.793,10.094c-2.185.03-7.1.04-12.687.04C62.236,77.108,49.088,77.072,48,77.069Z",
    transform: "translate(-8192.5 10719)",
    fill: "#822973"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654",
    transform: "translate(-8189.077 10773.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M-8177.93,10873c-2.368,4.358-4.8,8.972-5.207,9.563s.618,4.2,3.384,1.478,3.668-3.584,7.118-7.291S-8175.562,10868.637-8177.93,10873Z",
    transform: "translate(8183.222 -10871.182)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M-8176.925,10873c2.369,4.358,4.8,8.972,5.207,9.563s-.618,4.2-3.384,1.478-3.668-3.584-7.118-7.291S-8179.293,10868.637-8176.925,10873Z",
    transform: "translate(8261.051 -10871.182)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653",
    transform: "translate(-8185.474 10725.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    transform: "translate(0.474 2.154)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    transform: "translate(72.474 2.154)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    transform: "translate(13.474 0.154)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 15,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518",
    transform: "translate(-7.266 -53.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M-9367.858,8876.84l33.127-17.081-.416,1.775,1.17,33.245Z",
    transform: "translate(4234.837 -11997.908) rotate(-30)",
    fill: "#fff",
    stroke: "#793170",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501",
    transform: "translate(713.266 383.512) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 232.5, 73.46)",
    filter: "url(#Rectangle_1659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1659-2",
    "data-name": "Rectangle 1659",
    transform: "translate(232.5 73.93) rotate(180)",
    fill: "#fff",
    stroke: "#793170",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.168,
    height: 54.427,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134.168,
    height: 53.427,
    rx: 4.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    transform: "translate(135.168 40.394) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_0_0_1_2_3",
    "data-name": "0 0 1 2 3",
    fill: "#402b49",
    fontSize: 18,
    fontFamily: "SourceSansPro-Light, Source Sans Pro",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.208,
    y: 18
  }, "0 0 1 2 3"))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdxSerial);
export default __webpack_public_path__ + "static/media/idxSerial.8515cbb5b49b1d788bbce575e2289cfe.svg";
export { ForwardRef as ReactComponent };